._emptyText_1n6lv_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0px 19px 12px; }
